<template>
   <div class="flight-leg-wrapper">
      <!-- Flight Info Board -->
      <section class="flight-info-board">
         <h2>{{ leg.index }}. {{ $t("flightInformationsComponent_flight") }}</h2>
         <span class="flight-color masked-background-dark" :style="{ 'background-color': $options.filters.airlineColor(handlerLegColor) }"></span>
      </section>

      <div class="segments-wrapper">
         <div class="segment-inner-container" v-for="(segment, segmentIndex) in leg.segments" :key="segmentIndex">
            <!-- Segment Left Container -->
            <section class="segment-left">
               <!-- Departure Informations -->
               <div class="segment-information-box">
                  <span class="airport-name-abbr masked"> {{ segment.departureAirportCode }}</span>
                  <span class="airport-name masked"> {{ handlerAirportName(segment, "departure") }}</span>

                  <!-- <time :datetime="segment.time" class="masked" :class="segment.departureDateTimeChanged ? 'time-change-info' : ''"> -->

                  <time class="time-information masked" :class="segment.departureDateTimeChanged ? 'has-change' : ''">
                     {{ segment.departureDateTime | fullDateTextFormat }} {{ segment.departureDateTime | TimeFormat }}
                  </time>
               </div>

               <!-- Flight Informations -->
               <div class="segment-information-box centered">
                  <img
                     :src="[segment.marketingAirlineCode ? `${$constants.cdn}/airline_34x34/${segment.marketingAirlineCode}.svg` : '']"
                     @error="$event.target.src = `${$constants.cdn}/airline_34x34/00.svg`"
                     alt=""
                     width="48"
                     height="48"
                     class="masked-img" />

                  <span class="flight-number masked">{{ segment.flightNumber }}</span>

                  <time v-if="segment.travelTime" class="masked">
                     <UITooltip :tooltip-title="$t('flightInformationsComponent_travelDuration')" tooltip-icon="" tooltip-position="bottom" no-padding>
                        {{ segment.travelTime | duration }}
                     </UITooltip>
                  </time>
                  <span class="flight-operated-airline masked" v-if="segment.operatingAirlineCode != segment.marketingAirlineCode">
                     {{ $t("flightCard_operatedBy") }} {{ $t(`airlineEnum_${segment.operatingAirlineCode}`) }}
                  </span>
               </div>

               <!-- Arrival Informations -->
               <div class="segment-information-box">
                  <span class="airport-name-abbr masked">{{ segment.arrivalAirportCode }}</span>
                  <span class="airport-name masked">{{ handlerAirportName(segment, "arrival") }}</span>
                  <div class="time-information masked">
                     <time class="time-information masked" :class="segment.departureDateTimeChanged ? 'has-change' : ''">
                        {{ segment.arrivalDateTime | fullDateTextFormat }} {{ segment.arrivalDateTime | TimeFormat }}
                     </time>
                  </div>
               </div>
            </section>

            <!-- Segment Right Container -->
            <section class="segment-right">
               <div class="segment-row">
                  <div class="info-box">
                     <span class="info-title">{{ $t("flightInformationsComponent_cabinType") }}</span>
                     <div class="info-content masked" :class="segment.cabinTypeChanged ? 'has-change' : ''">{{ segment.cabinType | EFltCabinType }}</div>
                  </div>
                  <div class="info-box">
                     <span class="info-title">{{ $t("flightInformationsComponent_class") }}</span>
                     <div class="info-content masked" :class="segment.flightClassChanged ? 'has-change' : ''">{{ segment.flightClass }}</div>
                  </div>
               </div>

               <!-- BRAND NAME -->
               <!-- <div class="brandname-wrapper">
                  {{ segment.brandName }}
               </div> -->
               <div class="segment-row">
                  <div class="info-box">
                     <span class="info-title">{{ $t("flightInformationsComponent_lblBrandName") }}</span>
                     <div class="info-content masked">
                        <div class="brand-dropdown-wrapper masked">
                           <ul class="info-baggages brand-name masked" @click.stop="toggleBrandFeatures(segmentIndex)" style="cursor: pointer">
                              <li v-html="handlerBrandNameViewer(segment.brandName)"></li>
                              <i class="gts-icon icon-xs" :class="isBrandFeaturesOpen(segmentIndex) ? 'icon-arrow-up' : 'icon-arrow-down'"></i>
                           </ul>
                           <div v-if="isBrandFeaturesOpen(segmentIndex)" class="brand-features-dropdown" v-click-outside="closeBrandFeatures">
                              <ul class="brand-features">
                                 <li v-for="(ssr, idx) in getBrandFeatures(segment.brandName)" :key="idx">
                                    <i class="gts-icon icon-brand-item-check icon-sm" v-if="ssr.state == 1"></i>
                                    <i class="gts-icon icon-brand-item-x icon-sm" v-else></i>
                                    {{ ssr.info }}
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="segment-row">
                  <div class="info-box">
                     <span class="info-title">{{ $t("flightInformationsComponent_baggageAllowance") }}</span>
                     <div class="info-content masked">
                        <ul class="info-baggages">
                           <template v-for="(paxbag, paxkey, index) in segment.paxesBaggages">
                              <li v-if="paxbag === '-1KG'" :key="`unknown-${index}`" class="baggage-unknown">
                                 {{ $t("flightBrands_lblBaggageInfoUnknown") }}
                              </li>

                              <li v-else-if="paxbag.length > 0" :key="`bag-${index}`">{{ $t(`common_${paxkey.toLowerCase()}`) }}: {{ paxbag }}</li>
                           </template>
                        </ul>
                     </div>
                  </div>
               </div>
            </section>
         </div>
      </div>
   </div>
</template>

<script>
import UITooltip from "@/components/utils/GtsToolTips.vue";
export default {
   name: "FlightLeg",
   props: {
      leg: Object,
   },
   components: {
      UITooltip,
   },
   data() {
      return {
         openBrandFeatures: {},
      };
   },
   computed: {
      handlerLegColor() {
         const self = this;
         let color = null;
         Object.keys(self.leg.segments).forEach((segment) => {
            color = self.leg.segments[segment].marketingAirlineCode;
         });

         return color;
      },
   },
   methods: {
      toggleBrandFeatures(segmentIndex) {
         const currentState = this.openBrandFeatures[segmentIndex];
         this.openBrandFeatures = {};
         if (!currentState) {
            this.$set(this.openBrandFeatures, segmentIndex, true);
         }
      },
      closeBrandFeatures() {
         this.openBrandFeatures = {};
      },
      isBrandFeaturesOpen(segmentIndex) {
         return !!this.openBrandFeatures[segmentIndex];
      },
      getBrandFeatures(brandName) {
         if (!brandName || !this.leg.brands) return [];

         const brand = Object.values(this.leg.brands).find((b) => b.brandName === brandName);
         return brand?.ssrs || [];
      },
      handlerBrandNameViewer(brandName) {
         if (brandName) {
            return brandName.replace(/<[^>]*>/g, "");
         } else {
            return "-";
         }
      },
      handlerAirportName(segment, type) {
         const propertyName = `${type}AirportNameDic`;
         switch (this.$store.state.user.user.language) {
            case 1:
               return segment[propertyName]?.TURKISH;
            case 2:
               return segment[propertyName]?.ENGLISH;
            case 3:
               return segment[propertyName]?.GERMAN;
            default:
               return segment[propertyName]?.ENGLISH;
         }
      },
   },
};
</script>

<style lang="scss">
.dark-theme {
   .brand-name {
      background-color: var(--gray-0);
      li {
         color: var(--txt-white) !important;
      }
      i {
         filter: brightness(0) saturate(100%) invert(20%) sepia(84%) saturate(2879%) hue-rotate(191deg) brightness(92%) contrast(103%) !important;
      }
   }

   .brand-features-dropdown {
      background: var(--surface-level-0);
   }
   .brand-features li {
      background-color: var(--surface-level-0);
   }
}
.brand-name {
   color: var(--blue-600) !important;

   width: fit-content;

   border-radius: 0.25rem;
   font-weight: 600 !important;
}
.brand-name {
   display: flex;
   align-items: center;
   gap: 0.5rem;

   // background-color: var(--blue-200);
   background-color: color-mix(in srgb, var(--blue-200) 50%, transparent);
   width: fit-content;
   padding: 0.1rem 0.5rem;
   border-radius: 0.25rem;
   font-weight: 600 !important;
   font-size: var(--normal);
   font-weight: 500;

   li {
      color: var(--blue-700) !important;
   }
   i {
      filter: brightness(0) saturate(100%) invert(20%) sepia(84%) saturate(2879%) hue-rotate(191deg) brightness(92%) contrast(103%) !important;
   }
}

.brand-dropdown-wrapper {
   position: relative;

   i {
      flex-shrink: 0;
   }
}

.brand-features-dropdown {
   position: absolute;
   top: calc(100%);
   left: 50%;
   transform: translateX(-50%);
   z-index: 1000;
   background-color: var(--surface-level-1);
   border: 1px solid var(--gray-300);
   border-radius: 0.5rem;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
   min-width: 250px;
   max-width: 350px;
   // padding: 0.75rem 1rem;
   height: 300px;
   overflow-y: auto;
}

.brand-features {
   list-style: none;
   margin: 0;
   padding: 0;

   li {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      font-size: 0.875rem;
      color: var(--gray-600);
      padding: 0.25rem 0.5rem;
      margin: 0.125rem 0;
      border-radius: 0.5rem;

      &:nth-child(odd) {
         background-color: var(--gray-100);
      }
      &:nth-child(even) {
         border: 1px solid var(--gray-100);
      }

      i.gts-icon {
         font-size: 1.25rem;
         font-weight: 700;
         flex-shrink: 0;

         &.icon-brand-item-check {
            color: var(--green-600);
         }

         &.icon-brand-item-x {
            color: var(--red-500);
         }
      }
   }
}
</style>

<style lang="scss" scoped>
.baggage-unknown {
   background-color: var(--red-500);
   color: var(--txt-white) !important;
   padding: 0.125rem 0.25rem;
   border-radius: 0.25rem;
   font-size: 0.8rem !important;
   width: fit-content;
}
.brandname-wrapper {
   position: absolute;
   left: 0;

   top: -2px;
   margin: auto;
   width: -moz-fit-content;
   width: fit-content;
   background-color: var(--accent-primary);

   border-radius: 0.5rem;
   padding: 0.25rem 1rem;

   font-size: 13px;
   font-weight: 600;
   //color: var(--gray-50);
   color: var(--gray-0);
}
.flight-leg-wrapper {
   width: 100%;
   display: flex;
   flex-direction: column;
   margin-bottom: 1rem;
   position: relative;

   @media (min-width: 576px) {
      flex-direction: row;
   }

   .flight-info-board {
      border-radius: 10px;
      display: inline-flex;
      position: relative;
      overflow: hidden;
      flex-grow: 0;
      min-width: 45px;

      border: 1px solid var(--gray-300);

      h2 {
         writing-mode: horizontal-tb;
         text-orientation: unset;
         transform: rotate(0);
         text-align: center;
         font-size: var(--large);
         font-weight: 600;
         margin-left: 0.75rem !important;
         margin-right: 0.75rem !important;
         padding: 0.5rem 0;

         @media (min-width: 576px) {
            padding: 0;
            writing-mode: tb;
            transform: rotate(180deg);
         }
      }
      .flight-color {
         width: 24px;
         height: 24px;
         border-radius: 50%;
         display: inline-block;
         position: absolute;
         right: 0.5rem;
         top: 0;
         bottom: 0;
         margin: auto;

         @media (min-width: 576px) {
            width: 32px;
            height: 32px;
            right: 0;
            width: 4px;
            height: 70%;
            border-radius: 10px;
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
         }
      }
   }
   .segments-wrapper {
      width: 100%;
      margin-top: 1rem;

      @media (min-width: 576px) {
         margin-left: 1rem;
         margin-top: 0;
      }

      .segment-inner-container {
         display: flex;
         background: var(--gray-100);
         border-radius: 12px;
         border: 1.5px solid var(--gray-300);
         position: relative;
         padding: 1rem;

         margin: 0.75rem 0;
         flex-direction: column;

         @media (min-width: 576px) {
            flex-direction: row;
         }

         .segment-left {
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;

            @media (min-width: 576px) {
               width: 75%;
               border-right: 1px solid var(--gray-300);
            }

            .segment-information-box {
               display: flex;
               flex-direction: column;
               width: 100%;
               padding: 0 1rem;

               span.airport-name-abbr {
                  font-size: var(--large);
                  font-weight: 600;
                  color: var(--blue-400);
               }
               span.airport-name {
                  font-size: var(--small);
               }
               span.flight-number {
                  font-weight: 500;
                  font-size: var(--small);
               }
               span.flight-operated-airline {
                  font-weight: 400;
                  font-size: var(--xsmall);
                  color: var(--red-500);
               }
               .time-information {
                  display: flex;
                  align-items: center;

                  time {
                     font-size: var(--normal);
                     font-weight: 500;
                  }
               }

               &.centered {
                  align-items: center;
               }

               &.centered {
                  time {
                     font-size: var(--small);
                     strong {
                        font-weight: 400;
                     }
                  }
               }
            }
         }
         .segment-right {
            display: flex;
            width: 100%;
            justify-content: flex-start;
            align-items: left;
            padding: 0 1rem;
            border-top: 1px solid var(--gray-300);
            margin-top: 0.5rem;
            padding-top: 0.5rem;

            @media (min-width: 576px) {
               width: 25%;
               flex-direction: column;
               border-top: none;
               margin-top: 0;
               padding-top: 0;
            }

            @media (max-width: 576px) {
               display: grid !important;
               grid-template-columns: 1fr 1fr;
            }

            .segment-row {
               display: flex;
               margin-bottom: 0.5rem;

               &:last-child {
                  margin-bottom: 0 !important;
               }
               .info-box {
                  width: 100%;
                  padding: 0 1rem;
                  .info-title {
                     font-size: var(--small);
                     opacity: 0.8;
                     white-space: nowrap;
                  }
                  .info-content {
                     font-size: var(--large);
                     font-weight: 600;
                     // white-space: nowrap;
                     text-transform: capitalize;

                     ul.info-baggages {
                        li {
                           font-size: var(--normal);
                           font-weight: 500;
                           color: var(--gray-700);
                        }
                     }
                  }
               }
            }
         }

         &:first-child {
            margin-top: 0 !important;
         }
         &:last-child {
            margin-bottom: 0 !important;
         }
      }
   }
}
</style>
<style lang="scss">
.has-change {
   color: var(--red-500);
   font-weight: 500;
   position: relative;

   @keyframes attention {
      0% {
         opacity: 0;
      }
      80% {
         opacity: 1;
      }
      100% {
         opacity: 1;
      }
   }

   &::before {
      content: "";
      opacity: 0;
      width: 8px;
      height: 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      left: -0.75rem;
      border-radius: 50%;
      background-color: var(--red-500);
      animation-name: attention;
      animation-fill-mode: backwards;
      animation-iteration-count: infinite;
      animation-timing-function: ease-out;
      animation-duration: 1s;
   }
}
</style>
